/**
 * @file 主账号用量相关数据mixin
 */
import { mapGetters } from 'vuex';
// import { chargeTypeEnum } from '@/utils/type';
import { isNoAssignment, formatBytesToGb } from '@/utils/utils';
import { ynToBool } from '@polyv/utils/boolean';
export default {
  data() {
    return {
      addedChannels: 0,
      addedConCurrent: 0
    };
  },
  computed: {
    ...mapGetters({
      overViewInfo: 'account/overViewInfo',
    }),
    // 概览-直播信息
    liveInfo() {
      return this.overViewInfo?.liveInfo || {};
    },
    // 总账号是否开启无延迟直播
    isPureRtcEnabled() {
      return ynToBool(this.liveInfo.pureRtcEnabled ?? 'N');
    },
    // 概览-直播过期时间
    liveEndDate() {
      return this.overViewInfo?.liveEndDate;
    },
    // 是否允许设置云直播套餐 后端返回字段是否存在直播套餐过期时间或金额套餐过期时间
    isSetLiveSettingEnable() {
      return this.liveEndDate || this.amountEndDate;
    },
    // 是否允许设置云点播套餐 后端返回字段是否存在点播套餐过期时间或金额套餐过期时间
    isSetVodSettingEnable() {
      return this.vodEndDate || this.amountEndDate;
    },
    // 是否允许创建子账号，如果当前主账号没有打套餐，不允许创建子账号
    isCreateSubAccountEnable() {
      return this.isSetLiveSettingEnable || this.isSetVodSettingEnable;
    },
    // 概览-点播过期时间
    vodEndDate() {
      return this.overViewInfo?.vodEndDate;
    },
    // 概览-金额过期时间
    amountEndDate() {
      return this.overViewInfo?.amountEndDate;
    },
    // 是否金额模式
    isAmountType() {
      return (!this.liveEndDate && !this.vodEndDate) && this.amountEndDate;
    },
    // 主账号的用量方式
    concurrentType() {
      return this.overViewInfo?.chargeType;
    },
    // 是否有用量限制
    isResourceLimit() {
      return ynToBool(this.overViewInfo?.resourceLimit || 'N');
    },

    // 账号金额余额
    accountBalance() {
      if (!this.overViewInfo) return;
      const { balanceInfoVO: { validAmount, waitPayAmount } } = this.overViewInfo;
      return (validAmount - waitPayAmount) / 100000;
    },

    // 开启素材库
    materialEnabled() {
      return ynToBool(this.overViewInfo?.materialEnabled || 'N');
    },

    // 集团账号剩余素材库空间
    availableMaterialSpace() {
      const materialSpaceAssignable = this.overViewInfo?.assignableResourceVO?.materialSpaceAssignable;
      if (materialSpaceAssignable < 0) return 0;
      return Number(this.formatBytesToGb(materialSpaceAssignable).replace('G', ''));
    },

    // 集团账号剩余素材库流量
    availableMaterialTraffic() {
      const materialTrafficAssignable = this.overViewInfo?.assignableResourceVO?.materialTrafficAssignable;
      if (materialTrafficAssignable < 0) return 0;
      return Number(this.formatBytesToGb(materialTrafficAssignable).replace('G', ''));
    }
  },

  methods: {
    formatBytesToGb,
    $_getChannelTip(channels) {
      if (!this.overViewInfo || isNoAssignment(channels)) return;
      const { packageChannels, usedChannels } = this.overViewInfo;
      const remainChannels = packageChannels - usedChannels;
      return remainChannels >= channels ? `剩余可分配 ${remainChannels > 0 ? remainChannels : 0} 个` : '分配频道数不可超过集团账号最大频道数';
    },
    // 根据并发类型返回并发提示
    getConcurrentTipByChargeType(newConcurrent, oldConcurrent) {
      const { assignableResourceVO: { concurrenceAssignable }, chargeType } = this.overViewInfo;
      // 并行并发计算规则：主账号剩余可分配并发数 - 分账号已有并发数
      if (chargeType === 'parallelConcurrent') {
        const leftConcurrence = concurrenceAssignable - oldConcurrent;
        if (newConcurrent > leftConcurrence) {
          return '分配并发不可超过集团账号最高并发';
        }
        return `剩余可分配为 ${Math.max(leftConcurrence, 0)} 并发`;
      } else {
        // 累计并发计算规则： 主账号剩余可分配并发数
        return `剩余可分配为 ${concurrenceAssignable} 并发`;
      }
    },
    // 并发提示
    $_getConcurrentTip(newConcurrent, oldConcurrent) {
      if (!this.overViewInfo || isNoAssignment(newConcurrent)) return;
      // const { packageConcurrent } = this.overViewInfo;
      const { concurrenceAssignable } = this.overViewInfo.assignableResourceVO;

      // if (this.concurrentType === chargeTypeEnum.ParallelConcurrent) {
      // const remainConcurrent = packageConcurrent - concurrent - assistedConcurrent;

      // FIXME: 可抽离
      if (concurrenceAssignable <= 0) {
        if (newConcurrent && newConcurrent > 0) {
          return '分配并发不可超过集团账号最高并发';
        } else {
          return '剩余可分配为 0 并发';
        }
      } else if (newConcurrent <= concurrenceAssignable) {
        return this.getConcurrentTipByChargeType(newConcurrent, oldConcurrent);
      } else {
        return '分配并发不可超过集团账号最高并发';
      }
      // } else {

      //   const remainConcurrent = packageConcurrent - usedConcurrent;
      //   return remainConcurrent >= 0 ? `剩余可分配${remainConcurrent}` : '分配并发不可超过集团账号最高并发';
      // }
    },

    // 金额提示
    $_getBalanceTip(balance) {
      if (!this.overViewInfo || isNoAssignment(balance) || !this.isResourceLimit) return;
      const { assignableResourceVO: { amountAssignable } } = this.overViewInfo;
      return `剩余可分配${amountAssignable > 0 ? amountAssignable : 0}`;
    },

    $_getFlowTip(flow) {
      if (!this.overViewInfo || isNoAssignment(flow) || !this.isResourceLimit) return;
      const { vodInfo: { availableFlow } } = this.overViewInfo;
      const { assignableResourceVO: { trafficAssignable } } = this.overViewInfo;

      return flow <= availableFlow ? `剩余可分配 ${trafficAssignable > 0 ? trafficAssignable : 0} G` : '分配流量不可超过集团账号剩余点播流量';
    },

    $_getSpaceTip(space) {
      if (!this.overViewInfo || isNoAssignment(space) || !this.isResourceLimit) return;
      const { vodInfo: { availableSpace } } = this.overViewInfo;
      const { assignableResourceVO: { spaceAssignable } } = this.overViewInfo;
      return space <= availableSpace ? `剩余可分配 ${spaceAssignable > 0 ? spaceAssignable : 0} G` : '分配空间不可超过集团账号剩余点播空间';
    },

    $_getMaterialSpaceTip(space) {
      if (!this.overViewInfo || isNoAssignment(space)) return;
      const { availableMaterialSpace, assignableResourceVO: { materialSpaceAssignable } } = this.overViewInfo;
      return space <= availableMaterialSpace ? `剩余可分配 ${materialSpaceAssignable > 0 ? this.formatBytesToGb(materialSpaceAssignable) : 0 + ' G'}` : '分配空间不可超过集团账号剩余素材库空间';
    },

    $_getMaterialFlowTip(flow) {
      if (!this.overViewInfo || isNoAssignment(flow)) return;
      const { availableMaterialTraffic, assignableResourceVO: { materialTrafficAssignable } } = this.overViewInfo;
      return flow <= availableMaterialTraffic ? `剩余可分配 ${materialTrafficAssignable > 0 ? this.formatBytesToGb(materialTrafficAssignable) : 0 + ' G'}` : '分配流量不可超过集团账号剩余素材库流量';
    },

    $_getGuideMinutesTip(guideMinutes) {
      if (!this.overViewInfo || isNoAssignment(guideMinutes)) return;
      const { guideDurationAssignable } = this.overViewInfo.assignableResourceVO;

      if (guideDurationAssignable <= 0) {
        if (guideMinutes && guideMinutes > 0) {
          return '分配分钟数不可超过集团账号剩余导播台分钟数';
        } else {
          return '剩余可分配为 0 分钟';
        }
      } else if (guideMinutes <= guideDurationAssignable) {
        return `剩余可分配为 ${guideDurationAssignable} 分钟`;
      } else {
        return '分配分钟数不可超过集团账号剩余导播台分钟数';
      }
    },

    $_getMicMinutesTip(micMinutes) {
      if (!this.overViewInfo || isNoAssignment(micMinutes)) return;

      const { micDurationAssignable } = this.overViewInfo.assignableResourceVO;

      if (micDurationAssignable <= 0) {
        if (micMinutes && micMinutes > 0) {
          return '分配分钟数不可超过集团账号剩余连麦分钟数';
        } else {
          return '剩余可分配为 0 分钟';
        }
      } else if (micMinutes <= micDurationAssignable) {
        return `剩余可分配为 ${micDurationAssignable} 分钟`;
      } else {
        return '分配分钟数不可超过集团账号剩余连麦分钟数';
      }
    },

    $_getMinutesTip(minutes) {
      if (!this.overViewInfo || isNoAssignment(minutes)) return;
      const { durationAssignable } = this.overViewInfo.assignableResourceVO;

      return minutes <= durationAssignable ? `剩余可分配 ${durationAssignable > 0 ? durationAssignable : 0} 分钟` : '分配分钟数不可超过集团账号剩余分钟数';
    },

    $_getLiveFlowTip(flow) {
      if (!this.overViewInfo || isNoAssignment(flow)) return;
      const { liveFlowAssignable } = this.overViewInfo.assignableResourceVO;
      return flow <= liveFlowAssignable ? `剩余可分配 ${liveFlowAssignable} GB` : '分配流量不可超过集团账号剩余直播流量';
    },

    $_getResourceRecycleTip(number, unit) {
      return `剩余可回收 ${number} ${unit}`;
    },

    $_getAiPptVideoWithDigitalHumanDurationTips(minutes) {
      if (!this.overViewInfo || isNoAssignment(minutes)) return;

      const { aiPptVideoWithDigitalAssignable } = this.overViewInfo.assignableResourceVO;

      return minutes <= aiPptVideoWithDigitalAssignable ? `剩余可分配 ${aiPptVideoWithDigitalAssignable > 0 ? aiPptVideoWithDigitalAssignable : 0} 分钟` : '分配分钟数不可超过集团账号剩余分钟数';
    },

    $_getAiPptVideoDurationTips(minutes) {
      if (!this.overViewInfo || isNoAssignment(minutes)) return;

      const { aiPptVideoAssignable } = this.overViewInfo.assignableResourceVO;

      return minutes <= aiPptVideoAssignable ? `剩余可分配 ${aiPptVideoAssignable > 0 ? aiPptVideoAssignable : 0} 分钟` : '分配分钟数不可超过集团账号剩余分钟数';
    }
  }
};
